'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var certificateQuery = function certificateQuery() {
  return import('@/page/certificate-query');
};
exports.default = [{
  path: '/certificateQuery',
  name: 'certificateQuery',
  component: certificateQuery
}];